<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import { clothsData } from "./data-products";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

/**
 * Product detail component
 */
export default {
  page: {
    title: "Detalhe de Produto",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader },
  data() {
    return {
      updating: true,
      productDetail: null,
      clothsData: clothsData,
      title: "Detalhe de Produto",
      items: [
        {
          text: "Comercial",
          href: "/",
        },
        {
          text: "Detalhe de Produto",
          active: true,
        },
      ],
    };
  },
  created() {
    this.productDetail = clothsData.filter((product) => {
      return product.id === parseInt(this.$route.params.id);
    });
  },
  mounted() {
    this.totalRows = this.items.length;
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });
  },
  methods: {
    /**
     * Selected image shows
     */
    imageShow(event) {
      const image = event.target.src;
      const expandImg = document.getElementById("expandedImg");
      expandImg.src = image;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-6">
                <div class="product-detai-imgs">
                  <b-tabs
                      pills
                      vertical
                      nav-wrapper-class="col-md-2 col-sm-3 col-4"
                  >
                    <b-tab>
                      <template v-slot:title>
                        <img
                            :src="productDetail[0].images[0]"
                            alt
                            class="img-fluid mx-auto d-block tab-img rounded"
                        />
                      </template>
                      <div class="product-img">
                        <img
                            :src="productDetail[0].images[0]"
                            alt
                            class="img-fluid mx-auto d-block"
                        />
                      </div>
                    </b-tab>
                    <b-tab>
                      <template v-slot:title>
                        <img
                            :src="productDetail[0].images[1]"
                            alt
                            class="img-fluid mx-auto d-block tab-img rounded"
                        />
                      </template>
                      <div class="product-img">
                        <img
                            :src="productDetail[0].images[1]"
                            alt
                            class="img-fluid mx-auto d-block"
                        />
                      </div>
                    </b-tab>
                    <b-tab>
                      <template v-slot:title>
                        <img
                            :src="productDetail[0].images[2]"
                            alt
                            class="img-fluid mx-auto d-block tab-img rounded"
                        />
                      </template>
                      <div class="product-img">
                        <img
                            :src="productDetail[0].images[2]"
                            alt
                            class="img-fluid mx-auto d-block"
                        />
                      </div>
                    </b-tab>
                    <b-tab>
                      <template v-slot:title>
                        <img
                            :src="productDetail[0].images[3]"
                            alt
                            class="img-fluid mx-auto d-block tab-img rounded"
                        />
                      </template>
                      <div class="product-img">
                        <img
                            :src="productDetail[0].images[3]"
                            alt
                            class="img-fluid mx-auto d-block"
                        />
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>

              <div class="col-xl-6">
                <div class="mt-3">
                  <h4 class="mt-1 mb-3">{{ productDetail[0].name }}</h4>

                  <p class="text-muted float-left me-3">
                    <span class="bx bx-star text-warning"></span>
                    <span class="bx bx-star text-warning ml-1"></span>
                    <span class="bx bx-star text-warning ml-1"></span>
                    <span class="bx bx-star text-warning ml-1"></span>
                    <span class="bx bx-star ml-1"></span>
                  </p>
                  <p class="text-muted mb-4">( 152 Avaliações )</p>

                  <h6 class="text-success text-uppercase">
                    Desconto de {{ productDetail[0].discount }}%
                  </h6>
                  <h5 class="mb-4">
                    Valor:
                    <span class="text-muted me-2">
                      <del>R$ {{ productDetail[0].oldprice }} </del>
                    </span>
                    <b>R$ {{ productDetail[0].newprice }} </b>
                  </h5>
                  <p class="text-muted mb-4">
                    Descrição auxiliar produto, código fabricante.
                  </p>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div
                          v-for="(item, index) in productDetail[0].feature"
                          :key="index"
                      >
                        <p class="text-muted">
                          <i
                              class="bx bx-unlink font-size-16 align-middle text-primary me-1"
                          ></i>
                          {{ item }}
                        </p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div>
                        <p class="text-muted">
                          <i
                              class="bx bx-user-voice font-size-16 align-middle text-primary me-1"
                          ></i>
                          Newsletter
                        </p>
                        <p class="text-muted">
                          <i
                              class="bx bx-cog font-size-16 align-middle text-primary me-1"
                          ></i>
                          Garantia: 1 Ano
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="product-color">
                    <h5 class="font-size-15">Cor:</h5>
                    <a
                        href="javascript: void(0);"
                        class="active"
                        v-for="(item, index) in productDetail[0].colorVariant"
                        :key="index"
                    >
                      <div class="product-color-item border rounded">
                        <img :src="item.value" alt class="avatar-md" />
                      </div>
                      <p>{{ item.key }}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->

            <div class="mt-5">
              <h5 class="mb-3">Especificações</h5>

              <div class="table-responsive">
                <table class="table mb-0 table-bordered">
                  <tbody>
                  <tr
                      v-for="(i, index) in productDetail[0].specification"
                      :key="index"
                  >
                    <th scope="row" style="width: 400px">{{ i.key }}</th>
                    <td>{{ i.value }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- end Specifications -->

            <div class="mt-5">
              <h5 class="mb-4">Avaliações</h5>

              <div class="d-flex py-3 border-bottom">
                <img
                    src="@/assets/images/users/avatar-2.jpg"
                    class="avatar-xs me-3 rounded-circle"
                    alt="img"
                />
                <div class="flex-grow-1">
                  <h5 class="mt-0 font-size-15">João</h5>
                  <p class="text-muted">
                    Avaliação testes 00000.....
                  </p>
                  <ul class="list-inline float-sm-end">
                    <!--                    <li class="list-inline-item">-->
                    <!--                      <a href="javascript: void(0);">-->
                    <!--                        <i class="far fa-thumbs-up me-1"></i> Like-->
                    <!--                      </a>-->
                    <!--                    </li>-->
                    <li class="list-inline-item">
                      <a href="javascript: void(0);">
                        <i class="far fa-comment-dots me-1"></i> Responder
                      </a>
                    </li>
                  </ul>
                  <div class="text-muted">
                    <i class="far fa-calendar-alt text-primary me-1"></i> 5 horas atrás
                  </div>
                </div>
              </div>
              <div class="d-flex py-3 border-bottom">
                <img
                    src="@/assets/images/users/avatar-4.jpg"
                    class="avatar-xs me-3 rounded-circle"
                    alt="img"
                />
                <div class="flex-grow-1">
                  <h5 class="mt-0 font-size-15">Maria</h5>
                  <p class="text-muted">
                    Observação avaliação testes...
                  </p>
                  <ul class="list-inline float-sm-end">
                    <!--                    <li class="list-inline-item">-->
                    <!--                      <a href="javascript: void(0);">-->
                    <!--                        <i class="far fa-thumbs-up me-1"></i> Like-->
                    <!--                      </a>-->
                    <!--                    </li>-->
                    <li class="list-inline-item">
                      <a href="javascript: void(0);">
                        <i class="far fa-comment-dots me-1"></i> Responder
                      </a>
                    </li>
                  </ul>
                  <div class="text-muted">
                    <i class="far fa-calendar-alt text-primary me-1"></i> 07
                    Abr, 2023
                  </div>

                </div>
              </div>


            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!-- end row -->

    <div class="row mt-3" v-if="!updating">
      <div class="col-lg-12">
        <div>
          <h5 class="mb-3">Produtos Relacionados:</h5>

          <div class="row">
            <div class="col-xl-4 col-sm-6">
              <div class="card">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <img
                          src="@/assets/images/product/img-7.png"
                          alt
                          class="img-fluid mx-auto d-block"
                      />
                    </div>
                    <div class="col-md-8">
                      <div class="text-center text-md-start pt-3 pt-md-0">
                        <h5 class="mb-3 text-truncate">
                          <a href="javascript: void(0);" class="text-dark"
                          >Produto Testes 09008</a
                          >
                        </h5>
                        <p class="text-muted mb-4">
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star"></i>
                        </p>
                        <h5 class="my-0">
                          <span class="text-muted me-2">
                            <del>R$ 240</del>
                          </span>
                          <b>R$ 225</b>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6">
              <div class="card">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <img
                          src="@/assets/images/product/img-4.png"
                          alt
                          class="img-fluid mx-auto d-block"
                      />
                    </div>
                    <div class="col-md-8">
                      <div class="text-center text-md-start pt-3 pt-md-0">
                        <h5 class="mb-3 text-truncate">
                          <a href="javascript: void(0);" class="text-dark"
                          >Produto Testes 88771</a
                          >
                        </h5>
                        <p class="text-muted mb-4">
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star"></i>
                        </p>
                        <h5 class="my-0">
                          <span class="text-muted me-2">
                            <del>R$ 150</del>
                          </span>
                          <b>R$ 145</b>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6">
              <div class="card">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <img
                          src="@/assets/images/product/img-6.png"
                          alt
                          class="img-fluid mx-auto d-block"
                      />
                    </div>
                    <div class="col-md-8">
                      <div class="text-center text-md-start pt-3 pt-md-0">
                        <h5 class="mb-3 text-truncate">
                          <a href="javascript: void(0);" class="text-dark"
                          >Produto Testes 6443</a
                          >
                        </h5>
                        <p class="text-muted mb-4">
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star text-warning"></i>
                          <i class="bx bxs-star"></i>
                        </p>
                        <h5 class="my-0">
                          <span class="text-muted me-2">
                            <del>R$ 138</del>
                          </span>
                          <b>R$ 135</b>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
